export default __webpack_public_path__ + "media/Dairy-Butter.388f8ed0.png";